"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_design_system_1 = require("@hdh-core/react-design-system");
//import { FormattedMessage, useIntl } from 'react-intl'
const react_intl_1 = require("react-intl");
const transactionSigningSelector_1 = require("@/features/transaction-signing/selectors/transactionSigningSelector");
const constants_1 = require("../constants");
const transactionSigningAction_1 = require("../actions/transactionSigningAction");
const _className = 'rds-bg-pearl';
const _className2 = 'rds-pr-sm rds-pl-xl rds-pt-xl';
const TransactionSigningOfflineOTP = ({ onClose }) => {
    const intl = (0, react_intl_1.useIntl)();
    const dispatch = (0, react_redux_1.useDispatch)();
    //const [isOpen, setOpen] = useState(true)
    const [isOpen] = (0, react_1.useState)(true);
    const [otpError, setOtpError] = (0, react_1.useState)({});
    const { otpCode, errorMsg } = (0, react_redux_1.useSelector)(transactionSigningSelector_1.transactionSigningSelector);
    (0, react_1.useEffect)(() => {
        var _a;
        if (errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.msgId) {
            setOtpError((_a = intl.formatMessage({ id: errorMsg.msgId })) !== null && _a !== void 0 ? _a : errorMsg.defaultMsg);
        }
    }, [errorMsg]);
    const handleToggleCloseOfflineOTP = () => {
        console.log('handleToggleCloseApproved');
        dispatch((0, transactionSigningAction_1.dismissTransactionSigningOfflineOTPLayout)());
        dispatch((0, transactionSigningAction_1.setErrorMsg)(null));
        dispatch((0, transactionSigningAction_1.setOtpCode)(''));
        setOtpError({});
        onClose();
    };
    const handleOtpInputChange = (event) => {
        const { value } = event.target;
        if (value && value.length > 6) {
            return;
        }
        dispatch((0, transactionSigningAction_1.setErrorMsg)(null));
        setOtpError({});
        dispatch((0, transactionSigningAction_1.setOtpCode)(value));
    };
    const handleToggleSubmitOfflineOTP = () => {
        console.log('handleToggleSubmitOTP');
        dispatch((0, transactionSigningAction_1.setErrorMsg)(null));
        if (otpCode && otpCode.length === 6) {
            setOtpError({});
            dispatch((0, transactionSigningAction_1.toggleSubmitOfflineOtp)());
        }
        else {
            setOtpError(constants_1.PLESE_ENTER_THE_CORRECT_OTP);
        }
        dispatch((0, transactionSigningAction_1.setOtpCode)(''));
    };
    const onLostClick = () => {
        dispatch((0, transactionSigningAction_1.dismissTransactionSigningOfflineOTPLayout)());
        dispatch((0, transactionSigningAction_1.showTransactionSigningPrompter)());
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_design_system_1.Dialog, { id: "offlineTokenDialog", open: isOpen, onClose: handleToggleCloseOfflineOTP, type: 'normal', width: "600px" },
            react_1.default.createElement(react_design_system_1.Dialog.Title, { onClose: handleToggleCloseOfflineOTP }, intl.formatMessage({ id: 'transaction-signing-title' })),
            react_1.default.createElement(react_design_system_1.Dialog.Body, null,
                react_1.default.createElement(react_design_system_1.Box, { mb: 'md' },
                    react_1.default.createElement(react_design_system_1.Card, { className: _className, borderRadius: 'md', shadow: 'none', padding: '0' },
                        react_1.default.createElement(react_design_system_1.Row, null,
                            react_1.default.createElement(react_design_system_1.Col, { className: _className2, size: 8 },
                                react_1.default.createElement(react_design_system_1.Text, { component: 'div', size: 'sm', bold: true }, intl.formatMessage({ id: 'transaction-signing-otp-step1' })),
                                react_1.default.createElement(react_design_system_1.Text, { component: 'div', size: 'xs', className: 'rds-mt-xs' }, intl.formatMessage({ id: 'transaction-signing-otp-step1-dscp' }))),
                            react_1.default.createElement(react_design_system_1.Col, { size: 4, justifyContent: 'end', className: 'rds-pr-xl rds-pb-xl' },
                                react_1.default.createElement(react_design_system_1.Image, { width: '130', type: 'approve_trasaction_mobile_step_1', id: '' }))))),
                react_1.default.createElement(react_design_system_1.Box, { mb: 'md' },
                    react_1.default.createElement(react_design_system_1.Card, { shadow: 'none', borderRadius: 'md', padding: '0', className: _className },
                        react_1.default.createElement(react_design_system_1.Row, null,
                            react_1.default.createElement(react_design_system_1.Col, { size: 8, className: _className2 },
                                react_1.default.createElement(react_design_system_1.Text, { bold: true, size: 'sm', component: 'div' }, intl.formatMessage({ id: 'transaction-signing-otp-step2' })),
                                react_1.default.createElement(react_design_system_1.Text, { className: 'rds-mt-xs', size: 'xs', component: 'div' }, intl.formatMessage({ id: 'transaction-signing-otp-step2-dscp' }))),
                            react_1.default.createElement(react_design_system_1.Col, { className: 'rds-pr-sm', size: 4, justifyContent: 'end' },
                                react_1.default.createElement(react_design_system_1.Image, { type: 'approve_trasaction_mobile_step_2', width: '150', id: '' }))))),
                react_1.default.createElement(react_design_system_1.Box, { mb: 'md' },
                    react_1.default.createElement(react_design_system_1.Card, { shadow: 'none', padding: '0', className: _className, borderRadius: 'md' },
                        react_1.default.createElement(react_design_system_1.Row, null,
                            react_1.default.createElement(react_design_system_1.Col, { size: 8, className: _className2 },
                                react_1.default.createElement(react_design_system_1.Text, { size: 'sm', bold: true, component: 'div' }, intl.formatMessage({ id: 'transaction-signing-otp-step3' })),
                                react_1.default.createElement(react_design_system_1.Text, { size: 'xs', component: 'div', className: 'rds-mt-xs' }, intl.formatMessage({ id: 'transaction-signing-otp-step3-dscp' })),
                                react_1.default.createElement(react_design_system_1.Col, { size: 9, className: 'rds-mt-xs' },
                                    react_1.default.createElement(react_design_system_1.Input, { id: "offTokenOTP", label: '', placeholder: "Enter", isWhiteBg: true, value: otpCode, onChange: handleOtpInputChange, formatType: "numeric", maxLength: 6, error: otpError }))),
                            react_1.default.createElement(react_design_system_1.Col, { size: 4, justifyContent: 'end', className: 'rds-pr-lg rds-pl-lg rds-pb-3xl' },
                                react_1.default.createElement(react_design_system_1.Image, { type: 'approve_trasaction_mobile_step_3', width: '130', id: '' }))))),
                react_1.default.createElement(react_design_system_1.Row, { className: 'rds-pb-xl rds-pt-xs' },
                    react_1.default.createElement(react_design_system_1.Col, { size: 8 },
                        react_1.default.createElement(react_design_system_1.ButtonLink, { size: "xs", id: "lost", iconHeight: '20', iconWidth: '20', underline: false, icon: "chevron-right", onClick: onLostClick }, intl.formatMessage({ id: 'transaction-signing-otp-text-lostChangeSecurityToken' }))),
                    react_1.default.createElement(react_design_system_1.Col, { size: 4, className: 'rds-pl-xl' },
                        react_1.default.createElement(react_design_system_1.Button, { id: "offTokenSubmitBtn", onClick: handleToggleSubmitOfflineOTP }, intl.formatMessage({ id: 'common.button.btnSubmit' }))))))));
};
exports.default = TransactionSigningOfflineOTP;
